import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const actionType = {
	SetParams: '[Params] Action',
	ResetSetParams: '[Reset Params] Action',
};

const initialState = {
	params: [],
};

export const reducer = persistReducer(
	{ storage, key: 'params' },
	(state = initialState, action) => {
		switch (action.type) {
			case actionType.SetParams:
				return { ...state, ...action.payload };
			case actionType.ResetParams:
				return initialState;
			default:
				return state;
		}
	}
);

export const actions = {
	setParams: (data) => ({
		type: actionType.SetParams,
		payload: data,
	}),
	resetParams: () => ({ type: actionType.ResetParams }),
};
